import PropTypes from 'prop-types'
import { useEffect } from 'react'

import useNexiaStream from 'hooks/useNexiaStream'

import SystemStatusPanel from 'pages/Device/SystemStatusPanel'
import ZoneStatusPanel from 'pages/Device/ZoneStatusPanel'
import { useFeaturesContext } from 'hooks/FeaturesContext'
import { useWebsocketContext } from 'hooks/WebsocketContext'

import ExtendedDisconnect from 'pages/shared/Device/ExtendedDisconnect'

const propTypes = {
  deviceId: PropTypes.string.isRequired,
  hasAwairDevice: PropTypes.bool.isRequired,
  deviceModel: PropTypes.string.isRequired,
  reportCache: PropTypes.shape().isRequired
}

const Status = ({ deviceId, hasAwairDevice, reportCache, deviceModel }) => {
  const { eventData: report } = useNexiaStream(deviceId, 'current_status', reportCache)
  const { subscribe, unsubscribe, payload: wsReport } = useWebsocketContext(deviceId, 'system_status')

  const { enabledFeatures } = useFeaturesContext()
  const isWebsocketEnabled = enabledFeatures.includes('montblanc_websockets')

  useEffect(() => {
    if (isWebsocketEnabled) {
      subscribe(deviceId, 'system_status')
    }

    return () => {
      if (isWebsocketEnabled) {
        unsubscribe(deviceId, 'system_status')
      }
    }
  }, [deviceId, isWebsocketEnabled, subscribe, unsubscribe])

  const effectiveReport = isWebsocketEnabled ? wsReport?.systemStatus : report
  const extendedDisconnect = isWebsocketEnabled ? wsReport?.extendedDisconnect : false

  if (extendedDisconnect) {
    return <ExtendedDisconnect title="Status" type="normal" />
  }

  return (
    <>
      {effectiveReport && effectiveReport.zones.length > 1 && (
        <ZoneStatusPanel {...{ ...effectiveReport, ...hasAwairDevice }} />
      )}
      <SystemStatusPanel report={effectiveReport} hasAwairDevice={hasAwairDevice} showAll deviceModel={deviceModel} />
    </>
  )
}

Status.propTypes = propTypes

export default Status
